import { defineProperty as _defineProperty } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IlHeaderLogo from '../IlHeaderLogo/index.js';
import IlHeaderTitle from '../IlHeaderTitle/index.js';
import IlHeaderContent from '../IlHeaderContent/index.js';
import IlHeaderActions from '../IlHeaderActions/index.js';
import { cssClassPrefix } from '../../../shared/constants/generalConstants.js';

var BASE_CSS = "".concat(cssClassPrefix, "-header");

/**
 * IlHeader Component
 * #### Example implementation
 * ```javascript
 * <IlHeader>
 *  <IlHeaderLogo src="" onClick={() => void} alt="" />
 *  <IlHeaderTitle title="" onClick={() => void}/>
 *  <IlHeaderContent>
 *    ...
 *  </IlHeaderContent>
 *  <IlHeaderActions>
 *    <IlHeaderAction title="" onClick={() => void} icon={ReactElement} caretDown={ReactElement} userProfile={fullName: "", email: ""}>
 *      <IlHeaderActionItem itemText="" hasDivider={boolean} onClick={() => void} active={boolean} closeMenuOnClick={boolean}/>
 *    </IlHeaderAction>
 *  </IlHeaderActions>
 * </IlHeader>
 * ```
 * Good luck!
 */
var IlHeader = function IlHeader(props) {
  var getClasses = function getClasses() {
    var childrenTypes = React__default.Children.map(props.children, function (child) {
      return child.type;
    });
    return classNames(BASE_CSS, _defineProperty({}, "".concat(BASE_CSS, "--has-logo"), childrenTypes.indexOf(IlHeaderLogo) > -1), _defineProperty({}, "".concat(BASE_CSS, "--has-title"), childrenTypes.indexOf(IlHeaderTitle) > -1), _defineProperty({}, "".concat(BASE_CSS, "--has-content"), childrenTypes.indexOf(IlHeaderContent) > -1), _defineProperty({}, "".concat(BASE_CSS, "--has-actions"), childrenTypes.indexOf(IlHeaderActions) > -1));
  };
  return /*#__PURE__*/React__default.createElement("header", {
    className: getClasses()
  }, props.children);
};
IlHeader.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export { IlHeader as default };
